import { Avatar, Badge, Virtualizer } from "@productlane/ui"

import { ReportingChartFrame } from "@/components/reporting/charts"
import { api } from "@/lib/api"

export function AIUndeployedWorklist() {
	const query = api.analytics.aiAgentUndeployedWorklist.useQuery(
		{},
		{ staleTime: 30000 },
	)
	const rows = query.data?.rows ?? []
	const windowDays = query.data?.windowDays ?? 30
	const totalThreads = rows.reduce((sum, row) => sum + row.threads, 0)

	return (
		<ReportingChartFrame
			title="Deploy the agent"
			description={`Paying accounts with a live chat or email thread in the last ${windowDays} days and the Productlane Agent deployed to none of live chat, email, or Slack. Live chat carries no toggle of its own, so an account lands here whenever the agent is off. The count is their live chat and email threads in that window.`}
			isLoading={query.isLoading}
			isEmpty={!query.isLoading && rows.length === 0}
			emptyMessage="Every paying account with live chat or email volume runs the agent"
			legend={
				rows.length > 0 ? (
					<div className="text-right">
						<p className="text-2xl font-semibold tabular-nums text-primary">
							{totalThreads.toLocaleString("en-US")}
						</p>
						<p className="text-xs text-tertiary">live chat and email threads</p>
					</div>
				) : undefined
			}
		>
			<div className="text-sm">
				<div className="flex items-center gap-3 border-b border-gray-200 pb-2 text-xs text-tertiary dark:border-gray-700/80">
					<div className="min-w-0 flex-1">Workspace</div>
					<div className="w-16 flex-none">Plan</div>
					<div className="w-20 flex-none text-right">Live chat</div>
					<div className="w-16 flex-none text-right">Email</div>
					<div className="w-20 flex-none text-right">Threads</div>
				</div>
				<Virtualizer
					className="max-h-[320px] pb-2"
					estimateSize={36}
					itemsData={rows}
					itemContent={(row) => (
						<div className="flex items-center gap-3 py-1.5 hover:bg-gray-100 dark:hover:bg-gray-850/50">
							<div className="flex min-w-0 flex-1 items-center gap-2">
								<Avatar
									size="s"
									name={row.name || row.domain || ""}
									image={row.logoUrl}
								/>
								<span className="truncate">{row.name || row.domain}</span>
							</div>
							<div className="w-16 flex-none">
								<Badge variant="default" size="sm">
									{row.plan}
								</Badge>
							</div>
							<div className="w-20 flex-none text-right tabular-nums text-secondary">
								{row.liveChatThreads.toLocaleString("en-US")}
							</div>
							<div className="w-16 flex-none text-right tabular-nums text-secondary">
								{row.emailThreads.toLocaleString("en-US")}
							</div>
							<div className="w-20 flex-none text-right font-medium tabular-nums">
								{row.threads.toLocaleString("en-US")}
							</div>
						</div>
					)}
				/>
			</div>
		</ReportingChartFrame>
	)
}
